import styled from 'styled-components';

export const EditorModalFooter = styled.div`
  padding: 30px;
`;
